import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCardContext } from '../../../context/CardContext';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Text } from 'foundations-components/components/Text';
import { useHandleOpenEditAssociationModal } from '../../../hooks/useHandleOpenEditAssociationModal';
import { jsx as _jsx } from "react/jsx-runtime";
function AddAssociationLabelButton({
  association
}) {
  const {
    readOnly,
    objectPermissions
  } = useCardContext();
  const {
    handleOpenEditAssociationModal
  } = useHandleOpenEditAssociationModal(association);
  const canEditAssociation = (objectPermissions === null || objectPermissions === void 0 ? void 0 : objectPermissions.currentUserCanEditAssociations) && !readOnly;
  return /*#__PURE__*/_jsx(Link, {
    "data-test-id": "add-association-label-button",
    role: "button",
    onClick: handleOpenEditAssociationModal,
    "aria-label": I18n.text('cardAssociatedObjects.AssociatedObjectsActionBar.addAssociationLabel'),
    disabled: !canEditAssociation,
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      flexWrap: "nowrap",
      paddingBlock: "25",
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: I18n.text('cardAssociatedObjects.AssociatedObjectsActionBar.noPermissionToEditAssociation', {
          action: 'edit'
        }),
        "aria-label": I18n.text('cardAssociatedObjects.AssociatedObjectsActionBar.noPermissionToEditAssociation', {
          action: 'edit'
        }),
        placement: "top",
        disabled: canEditAssociation,
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          flexDirection: "row",
          gap: "100",
          flexWrap: "nowrap",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(TruncateString, {
              matchContentWidth: true,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardAssociatedObjects.AssociatedObjectsActionBar.addAssociationLabel"
              })
            })
          })
        })
      })
    })
  });
}
export default AddAssociationLabelButton;